import { sumOfMoney } from 'shared/util/money';
import type { PriceCleaningChoice, PrivateItemPrice } from '@/domain';
import { getCleaningDisplay } from './getCleaningDisplay';

export const getPriceCalculations = (
    privateItemPrice: PrivateItemPrice,
    startDate: Date,
    endDate: Date,
    cleaningChoice: PriceCleaningChoice,
    showConfirmedCleaning: boolean,
) => {
    const numberOfNights = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
    const nightsLabel = numberOfNights > 1 ? 'netter' : 'natt';
    const cleaningDisplay = getCleaningDisplay(
        privateItemPrice.cleaning.cleaningOption,
        cleaningChoice,
        privateItemPrice.cleaning.cleaningType,
        showConfirmedCleaning,
    );
    const totalPrice = privateItemPrice.total;
    const rentalPriceWithDiscount =
        privateItemPrice.rentalFee && privateItemPrice.discount
            ? sumOfMoney([privateItemPrice.rentalFee, privateItemPrice.discount])
            : privateItemPrice.rentalFee || { value: 0, currency: 'NOK' };

    return {
        numberOfNights,
        nightsLabel,
        cleaningDisplay,
        totalPrice,
        rentalPriceWithDiscount,
    };
};
